import styles from "./AddressInfo.module.scss";

type AddressStreetInfoExtendedAsianVariantProps = {
  streetNumber: string;
  streetName: string;
  streetAdditional: string;
  districtName: string;
  provinceName: string;
  city: string;
  postcode: string;
  countryName: string;
};

export const AddressStreetInfoExtendedAsianVariant = ({
  streetNumber = "",
  streetName = "",
  streetAdditional = "",
  districtName,
  provinceName,
  city,
  postcode,
  countryName,
}: AddressStreetInfoExtendedAsianVariantProps) => (
  <>
    <div data-testid="AddressInfoStreet">
      {streetNumber} {streetAdditional} {streetName}
    </div>

    <div data-testid="AddressInfoCity">{`${districtName}, ${city}, ${provinceName}`}</div>

    <div data-testid="AddressInfoCountry" className={styles.countryName}>
      {`${postcode}, ${countryName}`}
    </div>
  </>
);
